import { ANNULUS_CONDITION } from '../annulus-condition';
import { FlexiblePipeLayer } from './flexible-pipe-layer.model';

export class FadFlexStructure {
  id?: number;
  title: string;
  snCurveId: number;
  materialId: number;
  anularCondition: ANNULUS_CONDITION;
  layerConfiguration: FlexiblePipeLayer[];

  constructor(
    props = {
      id: null,
      title: '',
      snCurveId: -1,
      materialId: -1,
      anularCondition: ANNULUS_CONDITION.DRY,
      layerConfiguration: [],
    },
  ) {
    Object.assign(this, props);
  }
}
